import styles from './AnswerRejection.module.scss';

const AnswerRejection = () => {
  return <p className={styles['rejection']}>답변 거절</p>;
};

export default AnswerRejection;
